import {createAction, props} from "@ngrx/store";
import {FavoriteEntityType} from "../../enums/favorite-entity-type";
import {FavoriteId} from "../../ts-types/favorite-id";


export const setDistrictId = createAction(
  '[Rookie] Set District ID',
  props<{ districtId: number}>()
);

